import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppWithRouter } from './App';

const container = document.getElementById('root');

if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <AppWithRouter />
    </React.StrictMode>
  );
}